/**
 * Lets Connect chips (on ``connect_required`` tool rows) resume the agent
 * after OAuth without a second composer send from the clinician.
 */

import {
  createContext,
  createElement,
  useCallback,
  useContext,
  type ReactNode,
} from 'react';

export type ContinueAfterConnectFn = (connectorId: string) => void;

const ContinueAfterConnectContext = createContext<ContinueAfterConnectFn | null>(null);

export function ContinueAfterConnectProvider({
  onContinue,
  children,
}: {
  onContinue: ContinueAfterConnectFn;
  children: ReactNode;
}) {
  return createElement(
    ContinueAfterConnectContext.Provider,
    { value: onContinue },
    children
  );
}

export function useContinueAfterConnect(): ContinueAfterConnectFn | null {
  return useContext(ContinueAfterConnectContext);
}

/** Stable no-op for tests / surfaces outside Project chat. */
export function useContinueAfterConnectOrNoop(): ContinueAfterConnectFn {
  const ctx = useContinueAfterConnect();
  return useCallback(
    (connectorId: string) => {
      ctx?.(connectorId);
    },
    [ctx]
  );
}
